import React from 'react'
import { css } from '@emotion/core'

type SelectProps = {
  label?: string
  width?: string
  data?: any
  name?: string
  headquarterId?: string
  value?: string
  isExclusive?: boolean
  exclusiveHeadquarterId?: string
  onChange?: (e) => void
}

export const HeadquartersSelectField: React.FC<SelectProps> = ({
  label = '',
  width = '195px',
  name = '',
  data = [],
  value,
  isExclusive = false,
  exclusiveHeadquarterId,
  onChange,
}) => {
  return (
    <div css={[wrapperStyle, { width }]} className={'field'}>
      <label css={labelStyle} htmlFor={label}>
        {label}
      </label>
      <select css={selectStyle} id={label} name={name} onChange={onChange} value={value}>
        <option key={0} disabled={isExclusive}>
          全て
        </option>
        {data.map((item: any) => (
          <option
            key={item.headquarter_id}
            value={item.headquarter_id}
            disabled={isExclusive && item.headquarter_id !== exclusiveHeadquarterId}
          >
            {item.alias_name}
          </option>
        ))}
      </select>
    </div>
  )
}

const wrapperStyle = css({
  width: '150px',
})

const labelStyle = css({
  width: '100%',
  fontSize: '12px',
})

const selectStyle = css({
  appearance: 'none',
  width: '100%',
  border: '1px solid #D9D9D9',
  borderRadius: '22px',
  backgroundColor: '#FFFFFF',
  color: '#151619',
  fontSize: '12px',
  margin: '4px 0 0',
  padding: '6px 14px',
  backgroundImage: `url(${require('@/static/images/arrow_down.svg')})`,
  backgroundPosition: 'right 10px center',
  backgroundSize: '24px',
  backgroundRepeat: 'no-repeat',
})
